import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";
import { Box, Text } from "@similarweb/ui-components/foundations";

const HeaderText = styled(Text)`
    font-weight: 600;
`;

type AutocompleteDemandAnalysisSectionHeaderProps = {
    title: string;
};

export const AutocompleteDemandAnalysisSectionHeader: React.FC<AutocompleteDemandAnalysisSectionHeaderProps> = ({
    title,
}) => (
    <Box margin="8px 16px 14px 16px">
        <HeaderText
            fontVariant="sectionTitle"
            textTransform="uppercase"
            color={colorsPalettes.carbon[500]}
        >
            {title}
        </HeaderText>
    </Box>
);
